import React, { useState, useEffect, useRef } from "react";

import moment from "moment";
import { Link, useHistory } from "react-router-dom";
import AuditTrailheader from "./audittrailheader";

import { columnsCsv } from "./auditcontent";
import { options } from "./auditcontent";
import { getAuditTrailList } from "./../manageuserVerification/utils";
import { Audittraildata } from "../manageuserVerification/mockdata";

const AuditTrail = () => {
  const history = useHistory();
  const request = {
    page: 1,
    size: 10,
    datetime: "",
    email: "",
    action: "",
    actionon: "",
    ipaddress: "",
    role: "",
    searchFilter: "",
    toDate: "",
    fromDate: "",
  };
  const [filterForm, setFilterForm] = useState(request);
  const [modalShow, setModalShow] = useState(false);
  const [reassignshow, setReassignshow] = useState(false);
  const [searchBy, setSearchBy] = useState("Email");
  const [roleLabel, setRoleLabel] = useState([]);
  const [searchByValue, setSearchByValue] = useState("");
  const [filterValues, setFilterValues] = useState(false);
  const [adminStatus, setAdminStatus] = useState(false);
  const [superadminStatus, setSuperadminStatus] = useState(false);
  const [callcentreagentStatus, setCallcentreagentStatus] = useState(false);
  const [customerserviceStatus, setCustomerserviceStatus] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [noOfFiltersSelected, setNoOfFiltersSelected] = useState(false);
  const [filtersSelected, setFiltersSelected] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [auditTrailList, setauditTrailList] = useState([]);
  const [auditTrailListExcel, setauditTrailListExcel] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState();
  const [excelLoading, setExcelLoading] = useState(false);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
  });
  const [sizeShow, setSizeShow] = useState();
  const buttonRef = useRef("");

  const columns = [
    {
      dataField: "date",
      text: "Date",
      sort: true,
      style: { maxWidth: "50px", textAlign: "center" },
      headerStyle: { textAlign: "center" },

      formatter: (cell, row) => {
        return moment((row && row.date) || null).format("DD-MM-YY  HH:mm:ss");
      },
    },
    {
      dataField: "email",
      text: "Email",
      sort: false,
      headerStyle: { textAlign: "left" },
      style: { maxWidth: "150px", textAlign: "left" },
    },
    {
      dataField: "action",
      text: "Action ",
      sort: false,
      headerStyle: { textAlign: "left" },
      style: { minWidth: "50px", textAlign: "left" },
    },
    {
      dataField: "actionOn",
      text: "Action On",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "50px", textAlign: "center" },
    },

    // {
    //   dataField: "ipaddress",
    //   text: "IP Address",
    //   sort: false,
    //   headerStyle: { textAlign: "center" },
    //   style: { minWidth: "100px", textAlign: "center" },
    // },
    // {
    //   dataField: "role",
    //   text: "Role",
    //   sort: false,
    //   headerStyle: { textAlign: "center" },
    //   style: { minWidth: "100px", textAlign: "center" },
    // },
  ];

  const rowClicked = (data) => {
    let states = { ...data };
    console.log(states);
    history.push({
      pathname: "/admin/user-profile",
      state: { id: states.id, rowData: states },
    });
  };

  useEffect(() => {
    if (filterForm) {
      getauditTrails(filterForm);
    }
  }, [filterForm]);
  const [roleData, setRoleData] = useState([]);
  // useEffect(() => {

  //   const roleValue = async () => {
  //     let roleRes = await role();
  //     setRoleData(roleRes.data);
  //     console.log("Audit roledata", roleData);
  //   };
  //   roleValue();
  // }, [auditTrailList]);

  const getauditTrails = (request) => {
    request.size = sizeShow || 10;
    setDataLoading(true);
    getAuditTrailList(request)
      .then((res) => {
        setDataLoading(false);

        if (res && res.data && res.data.auditTrails.length > 0) {
          setauditTrailList(() => res.data.auditTrails);
          auditTrailList.map((list) => {
            if (list.roleId === roleData.id) {
              setRoleLabel(roleData.name);
            }
          });
          // const newData = auditTrailList.map((list)=>list.roleId === roleData.id)
        } else {
          setauditTrailList([]);
        }
        setPagination({
          ...pagination,
          pageSize: sizeShow || 10,
          total: res.data.totalCount,
          current: request.page,
        });
      })
      .catch((err) => {
        setPagination({ ...pagination, pageSize: 10, total: 0, current: 1 });
        setDataLoading(false);
        setauditTrailList(Audittraildata);
      });
  };

  const resetFilter = () => {
    setSearchBy("Email");
    // setSearchByValue('');
    setFiltersSelected(false);
    setauditTrailList([]);
    setauditTrailListExcel([]);

    setSelectedOption("");
    setFilterValues(false);
    setSearchByValue("");
    setFromDate("");
    setToDate("");
    setFilterForm(request);
  };

  const handleFIlter = () => {
    let request = {};
    if (searchBy === "Email") {
      request = {
        ...filterForm,
        datetime: "",
        email: searchByValue,
        action: "",
        actionon: "",
        ipaddress: "",
        role: "",
      };
    } else if (searchBy === "Action") {
      request = {
        ...filterForm,
        datetime: "",
        email: "",
        action: searchByValue,
        actionon: "",
        ipaddress: "",
        role: "",
      };
    } else if (searchBy === "ActionOn") {
      request = {
        ...filterForm,
        datetime: "",
        email: "",
        action: "",
        actionon: searchByValue,
        ipaddress: "",
        role: "",
      };
    }
    request.searchFilter = "";
    let a = "";
    if (selectedOption.length > 0) {
      selectedOption.forEach((v, i) => {
        a = a + v.value + (i + 1 < selectedOption.length ? "," : "");
      });
    }
    request.page = 1;
    request.searchFilter = a; // TODO - NEED TO REMOVE
    request.fromDate =
      (fromDate && moment(fromDate).format("YYYY-MM-DD")) || "";
    request.toDate = (toDate && moment(toDate).format("YYYY-MM-DD")) || "";
    setFilterForm(request);
  };

  const handleChange = (selectedOption) => {
    console.log(selectedOption);
    if (selectedOption) {
      setSelectedOption([...selectedOption]);
    } else {
      setSelectedOption("");
    }
  };

  let searchByValuePlaceholder = "";

  if (searchBy === "Email") {
    searchByValuePlaceholder = "123@gmail.com";
  } else if (searchBy === "Action") {
    searchByValuePlaceholder = "Action Performed";
  } else if (searchBy === "ActionOn") {
    searchByValuePlaceholder = "67XXXXXX90";
  }

  const onExcelClciked = (filterForm) => {
    let request = filterForm;
    request.page = 1;
    request.size = "";
    setExcelLoading(true);
    getAuditTrailList(request)
      .then((res) => {
        if (res && res.data && res.data.auditTrails.length > 0) {
          let data = res.data.auditTrails.map((element) => {
            if (element.date) {
              element.date = moment(element.date).format("DD-MM-YYYY");
            }
            return element;
          });
          setauditTrailListExcel(() => data);
          setExcelLoading(false);
          buttonRef.current.click();
        } else {
          setauditTrailListExcel([]);
        }
      })
      .catch((err) => {
        setauditTrailListExcel([]);
      });
  };

  console.log(columnsCsv);
  return (
    <AuditTrailheader
      searchBy={searchBy}
      setFromDate={setFromDate}
      setToDate={setToDate}
      fromDate={fromDate}
      toDate={toDate}
      setSearchByValue={setSearchByValue}
      setSearchBy={setSearchBy}
      searchByValuePlaceholder={searchByValuePlaceholder}
      searchByValue={searchByValue}
      setModalShow={setModalShow}
      setReassignshow={setReassignshow}
      filtersSelected={filtersSelected}
      noOfFiltersSelected={noOfFiltersSelected}
      resetFilter={resetFilter}
      handleFIlter={handleFIlter}
      filterValues={filterValues}
      auditTrailList={auditTrailList}
      dataLoading={dataLoading}
      buttonRef={buttonRef}
      filterForm={filterForm}
      onExcelClciked={onExcelClciked}
      auditTrailListExcel={auditTrailListExcel}
      columns={columns}
      columnsCsv={columnsCsv}
      pagination={pagination}
      setFilterForm={setFilterForm}
      excelLoading={excelLoading}
      setSizeShow={setSizeShow}
      modalShow={modalShow}
      reassignshow={reassignshow}
      handleChange={handleChange}
      options={options}
      selectedOption={selectedOption}
    />
  );
};

export default AuditTrail;
